import { Global, css } from '@emotion/react'
import { CAMPAIGNS } from '@/constants/campaigns'

export const defaultFonts = css`
  @font-face {
    font-family: 'Roboto-Bold';
    font-display: swap;
    src: url('/static/assets/fonts/Roboto-Bold.woff') format('woff');
  }
  @font-face {
    font-family: 'Roboto-Regular';
    font-display: swap;
    src: url('/static/assets/fonts/Roboto-Regular.woff') format('woff');
  }
  @font-face {
    font-family: 'Roboto-Light';
    font-display: swap;
    src: url('/static/assets/fonts/Roboto-Light.woff') format('woff');
  }
  @font-face {
    font-family: 'DINNext79-Bold';
    font-display: swap;
    src: url('/static/assets/fonts/DINNext79-Bold.ttf') format('truetype');
  }
  @font-face {
    font-family: 'DINNext79-CnBold';
    font-display: swap;
    src: url('/static/assets/fonts/DINNext79-CnBold.ttf') format('truetype');
  }
  @font-face {
    font-family: 'DINNext79-Regular';
    font-display: swap;
    src: url('/static/assets/fonts/DINNext79-Regular.ttf') format('truetype');
  }
  @font-face {
    font-family: 'DINNext79-Md';
    font-display: swap;
    src: url('/static/assets/fonts/DINNext79-Md.ttf') format('truetype');
  }
  @font-face {
    font-family: 'DINNext79-MdCn';
    font-display: swap;
    src: url('/static/assets/fonts/DINNext79-MdCn.ttf') format('truetype');
  }
  @font-face {
    font-family: 'DINNext79-Lt';
    font-display: swap;
    src: url('/static/assets/fonts/DINNext79-Lt.ttf') format('truetype');
  }
  @font-face {
    font-family: 'DINNext79-LtCn';
    font-display: swap;
    src: url('/static/assets/fonts/DINNext79-LtCn.ttf') format('truetype');
  }

  @keyframes shake {
    0% {
      transform: rotate(2deg);
    }
    10% {
      transform: rotate(-4deg);
    }
    20% {
      transform: rotate(2deg);
    }
    30% {
      transform: rotate(-4deg);
    }
    40% {
      transform: rotate(2deg);
    }
    50% {
      transform: rotate(-4deg);
    }
    60% {
      transform: rotate(2deg);
    }
    70% {
      transform: rotate(0deg);
    }
    80% {
      transform: rotate(0deg);
    }
    90% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }
`

export const getCampaignFonts = (campaign: Campaign) =>
  ({
    [CAMPAIGNS.BYDB.name]: [
      <link
        rel="preload"
        href="/static/assets/fonts/DINNext79-LtCn.ttf"
        as="font"
        crossOrigin=""
        type="font/ttf"
        key="din-light-cn"
      />,
      <link
        rel="preload"
        href="/static/assets/fonts/DINNext79-MdCn.ttf"
        as="font"
        crossOrigin=""
        type="font/ttf"
        key="din-medium-cn"
      />,
      <link
        rel="preload"
        href="/static/assets/fonts/DINNext79-CnBold.ttf"
        as="font"
        crossOrigin=""
        type="font/ttf"
        key="din-bold-cn"
      />,
    ],
    [CAMPAIGNS.GREATESTHITS.name]: [
      <link
        rel="preload"
        href="/static/assets/fonts/Roboto-Regular.woff"
        as="font"
        crossOrigin=""
        type="font/woff2"
        key="roboto-regular"
      />,
      <link
        rel="preload"
        href="/static/assets/fonts/Roboto-Light.woff"
        as="font"
        crossOrigin=""
        type="font/woff2"
        key="roboto-light"
      />,
      <link
        rel="preload"
        href="/static/assets/fonts/Roboto-Bold.woff"
        as="font"
        crossOrigin=""
        type="font/woff2"
        key="roboto-bold"
      />,
    ],
    [CAMPAIGNS.ULTIMATECOACHINGTRIP.name]: [
      <link
        rel="preload"
        href="/static/assets/fonts/Roboto-Regular.woff"
        as="font"
        crossOrigin=""
        type="font/woff2"
        key="roboto-regular"
      />,
      <link
        rel="preload"
        href="/static/assets/fonts/Roboto-Light.woff"
        as="font"
        crossOrigin=""
        type="font/woff2"
        key="roboto-light"
      />,
      <link
        rel="preload"
        href="/static/assets/fonts/Roboto-Bold.woff"
        as="font"
        crossOrigin=""
        type="font/woff2"
        key="roboto-bold"
      />,
    ],
    [CAMPAIGNS.SPINTOWIN.name]: [
      <link
        rel="preload"
        href="/static/assets/fonts/DINNext79-Md.ttf"
        as="font"
        crossOrigin=""
        type="font/ttf"
        key="din-next-md"
      />,
      <link
        rel="preload"
        href="/static/assets/fonts/DINNext79-Bold.ttf"
        as="font"
        crossOrigin=""
        type="font/ttf"
        key="din-next-bold"
      />,
      <link
        rel="preload"
        href="/static/assets/fonts/DINNext79-Regular.ttf"
        as="font"
        crossOrigin=""
        type="font/ttf"
        key="din-next-regular"
      />,
      <link
        rel="preload"
        href="/static/assets/fonts/DINNext79-Lt.ttf"
        as="font"
        crossOrigin=""
        type="font/ttf"
        key="din-next-light"
      />,
      <link
        rel="preload"
        href="/static/assets/fonts/DINNext79-LtCn.ttf"
        as="font"
        crossOrigin=""
        type="font/ttf"
        key="din-next-light-cn"
      />,
      <link
        rel="preload"
        href="/static/assets/fonts/DINNext79-MdCn.ttf"
        as="font"
        crossOrigin=""
        type="font/ttf"
        key="din-next-medium-cn"
      />,
      <link
        rel="preload"
        href="/static/assets/fonts/DINNext79-CnBold.ttf"
        as="font"
        crossOrigin=""
        type="font/ttf"
        key="din-next-bold-cn"
      />,
    ],
  })[campaign]

export const GlobalComponent = () => <Global styles={defaultFonts} />
